// extracted by mini-css-extract-plugin
module.exports = {"legend":"POILegend_legend__dD1kO","I":"POILegend_I__itLvr","showMore":"POILegend_showMore__Q554b","Button":"POILegend_Button__iR0a5","h4":"POILegend_h4__qthKx"};